module.exports = __webpack_public_path__ + "static/media/clear-communication.ea45e83b.svg";